import type { PropsWithChildren } from 'react';

import { Heading } from '@backyard-ui/core';

interface TitleProps extends PropsWithChildren {}

function Title(props: TitleProps) {
  const { children } = props;

  return (
    <Heading size="xl" asChild>
      <h3>{children}</h3>
    </Heading>
  );
}

export default Title;
